import React, { useEffect, useState } from "react";
import { Table, Avatar, Spin, Tabs, Tag, Button } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import henceforthApi from "../utils/henceforthApi";
import { getUserProfileImage } from "../utils/constant_value";

const { TabPane } = Tabs;

const ReportedChat = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [chatType, setChatType] = useState("USER"); // USER = one-to-one, GROUP = group chats

  const fetchData = async (page = 1, type = chatType) => {
    setLoading(true);
    try {
      const res = await henceforthApi.Reported.reportedChatList(
        type,
        page - 1, // API expects pagination starting from 0
        pagination.pageSize
      );

      setData(res.reports || []);
      setPagination({
        current: page,
        pageSize: pagination.pageSize,
        total: res.count || 0,
      });
    } catch (err) {
      console.error("Error fetching reported chat list:", err);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(1, chatType);
  }, [chatType]);


    <div className="d-flex gap-1 ProfileImagePRS-box">
      
    </div>

  const columns = [
    {
      title: "Sr. No.",
      key: "serial",
      render: (_, __, index) =>
        (pagination.current - 1) * pagination.pageSize + (index + 1),
    },
    {
      title: "Reported By",
      dataIndex: "report_by",
      key: "report_by",
      render: (report_by) => (
        <span>
         <Avatar
            src={getUserProfileImage(report_by?.profile_pic, 'medium')}
          />
        <Link
          to={`/user/${report_by?._id}/1/1?type=posts`}
          className="Details_of_User"
        >
         <span style={{ marginLeft: 8 }}>{report_by?.full_name || "-"}</span> 
        </Link >
        </span>
      ),
    },
    {
      title: chatType === "USER" ? "Reported to" : "Group Name",
      dataIndex: chatType === "USER" ? "report_to" : "group_name",
      key: chatType === "USER" ? "report_to" : "group_name",
      render: (value, record) => {
        return chatType === "USER" ? (
           <span>
         <Avatar
            src={getUserProfileImage(value?.profile_pic, 'medium')}
          />
        <Link
          to={`/user/${value?._id}/1/1?type=posts`}
          className="Details_of_User"
        >
         <span style={{ marginLeft: 8 }}>{value?.full_name || "-"}</span> 
        </Link >
        </span>
        ) : (
          <span>{value || "-"}</span>
        );
      },
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      render: (reason) => <Tag color="red">{reason || "-"}</Tag>,
    },
    {
      title: "Reported Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (_, record) =>
        record?.created_at
          ? new Date(record.created_at).toLocaleString()
          : "-",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Link
          to={`/reported-chat/${record._id}/view`}
          state={{ record }} 
        >
          <Button size="small" icon={<EyeOutlined />}>
            View
          </Button>
        </Link>
      ),
    },
  ];

  return (
    <div>
      

      <Tabs defaultActiveKey="USER" onChange={(key) => setChatType(key)}>
        <TabPane tab="User to User" key="USER" />
        <TabPane tab="Group Chats" key="GROUP" />
      </Tabs>

      <Spin spinning={loading}>
        <Table
          rowKey={(record) => record._id}
          dataSource={data}
          columns={columns}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            onChange: (page) => fetchData(page),
          }}
        />
      </Spin>
    </div>
  );
};

export default ReportedChat;
